import { createContext } from "react";
const LoadingStateContext = createContext({
    loadingStatusMessages: [],
    setLoadingStatusMessage: null,
    loadingHotelSkeleton: false,
    setLoadingHotelSkeleton: null
});
export { LoadingStateContext };
